import axios from "axios"

const configApi = {
    getUpdateList: (params) => {
        const url = `/config/update`
        return axios.get(url, params)
    },
    addUpdate: (params) => {
        const url = '/config/update'
        return axios.post(url, params)
    },
    getUpdateInfo: (updateSettingId) => {
        const url = `/config/update/${updateSettingId}`
        return axios.get(url)
    },
    patchUpdate: (updateSettingId, params) => {
        const url = `/config/update/${updateSettingId}`
        return axios.patch(url, params)
    },
    getNewUpdateInfo: () => {
        const url = `/config/update/new`
        return axios.get(url)
    },
}

export default {
    install(app) {
        app.config.globalProperties.configApi = configApi
    }
}
